const VEHICLES = ["hatchback", "sedan", "suv", "luxury"];

const DustingRateModal = ({ rates, setRates, loading, onClose, onSave }) => (
  <div className="custom-modal-overlay">
    <div className="custom-modal dusting-rate-modal">
      <div className="custom-modal-header">
        <div>
          <h4>Dusting Rate</h4>
          <small>One rate per car type. Saving updates all existing fares for this city.</small>
        </div>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>
      <div className="custom-modal-body">
        <div className="form-grid">
          {VEHICLES.map((vehicle) => (
            <div className="form-group" key={vehicle}>
              <label>{vehicle.charAt(0).toUpperCase() + vehicle.slice(1)} (₹)</label>
              <input type="number" min="0" value={rates?.[vehicle] ?? ""} onChange={(event) => setRates((prev) => ({ ...prev, [vehicle]: event.target.value }))} />
            </div>
          ))}
        </div>
      </div>
      <div className="custom-modal-footer">
        <button className="btn btn-dark" onClick={onClose}>Cancel</button>
        <button className="btn btn-success" disabled={loading} onClick={onSave}>{loading ? "Saving..." : "Save rates"}</button>
      </div>
    </div>
  </div>
);

export default DustingRateModal;
